import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule, AutoCompleteModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { LaddaModule } from 'angular2-ladda';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { SlideToggleModule } from 'ngx-slide-toggle';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ClaimsService } from '../../_services/claims.service';
import { CanDeactivateGuard } from '../../_guards/can-deactivate.guard';
import { DuePaymentsComponent } from './due-payments/due-payments.component';
import { PaymentsService } from './payments.service';
import { PaymentsRoutingModule } from './payments-routing.module';
import { PaymentInstallmentComponent } from './payment-installment/payment-installment.component';
import { PaymentInstallmentListComponent } from './payment-installment-list/payment-installment-list.component';
import { PaymentInstallmentDetailComponent } from './payment-installment-detail/payment-installment-detail.component';
import { OffsetMasterComponent } from './payment-installment-detail/offset-master/offset-master.component';
import { OffsetDetailComponent } from './payment-installment-detail/offset-master/offset-detail/offset-detail.component';
import { DueOffsetDetailComponent } from './due-payments/due-offset-detail/due-offset-detail.component';
@NgModule({
  declarations: [DuePaymentsComponent, PaymentInstallmentComponent, PaymentInstallmentListComponent, PaymentInstallmentDetailComponent, OffsetMasterComponent, OffsetDetailComponent, DueOffsetDetailComponent],
  imports: [
    CommonModule,
    PaymentsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    InputsModule,
    SlideToggleModule,
    DropDownsModule,
    GridModule,
    DateInputsModule,
    LaddaModule,
    ButtonsModule,
    DialogsModule,
    TooltipModule,
    TabsModule,
    AutoCompleteModule,
  ],
  providers: [PaymentsService, ClaimsService,
    CanDeactivateGuard]
})
export class PaymentsModule { }
